export function parseSignupResponse(rep) {
  let { authorization_uri, redirect_uri } = rep.data;
  return Promise.resolve({
    link: authorization_uri,
    redirect_uri,
  })
}